import { useState, useEffect } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

const RV_LOGO_STORAGE_PATH = 'RV LOGO/RV_LOGO.png';

// Module-level cache so every component instance shares one fetch
let cachedUrl: string | null = null;
let pending: Promise<string> | null = null;

async function fetchLogoUrl(): Promise<string> {
  if (cachedUrl) return cachedUrl;
  if (!pending) {
    pending = getDownloadURL(ref(storage, RV_LOGO_STORAGE_PATH)).then((url) => {
      cachedUrl = url;
      return url;
    });
  }
  return pending;
}

export function useRvLogo(): string | undefined {
  const [url, setUrl] = useState<string | undefined>(cachedUrl ?? undefined);

  useEffect(() => {
    if (cachedUrl) { setUrl(cachedUrl); return; }
    let cancelled = false;
    fetchLogoUrl()
      .then((u) => { if (!cancelled) setUrl(u); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return url;
}
